const PROVIDER_ACCREDITATION_BASE_ROUTE = '/credenciamento-prestador/:nrSeqUser';
const LOGIN_BASE_ROUTE = '/login';

function mountRoute(route: string, prefix: string = PROVIDER_ACCREDITATION_BASE_ROUTE): string {
  return `${prefix}${route}`;
}

export const FOUNDATION_ROUTES = {
  LOGIN: mountRoute('', LOGIN_BASE_ROUTE),
  INACTIVITY: '/inatividade',
  FORGOT_PW: mountRoute('/redefinir-senha', LOGIN_BASE_ROUTE),
  CONFIRM_USER_NEW_PW: '/confirmar-usuario/:hash/nova-senha',
  NEW_PW: '/nova-senha/:hash',
  REDIRECT: '/credenciamento-prestador',
  RENEW_PW_BY_USERNAME: mountRoute('/renovar-senha/:nrSequence', LOGIN_BASE_ROUTE),
};

export const APPLICATION_ROUTES = {
  CALLS: mountRoute('/chamados'),
  NEGOTIATION: mountRoute('/historico-negociacoes'),
  PROVIDER_ACCREDITATION: mountRoute('/credenciamento'),
  TECHNICAL_VISIT: mountRoute('/visita-tecnica'),
  TECHNICAL_VISIT_DETAILS:  mountRoute('/visita-tecnica/:nrSeqVisit'),
};

export const Route = {
  ACCREDITATION: '/credenciamento/:nrSeqAccreditation/tipo-credenciamento/:nrSeqTypeAccreditation/temp',
  TERM_OF_USE: '/login/novo-usuario/termo-de-uso/:nrSeqTerm',
  PRIVACY_WARNING: '/login/novo-usuario/aviso-de-privacidade/:nrSeqWarning',
  NEW_USER_CONFIRMATION: '/confirmar-usuario/:hash',
  NEW_CALL: mountRoute('/chamados/tipo-solicitacao/:nrSeqCategory/novo'),
  DETAILS_CALLED: mountRoute('/chamados/:nrSeqCall/detalhes'),
  NEW_PROVIDER_ACCREDITATION: mountRoute('/credenciamento/tipo-credenciamento/:nrSeqTypeAccreditation/novo'),
  DETAIL_PROVIDER_ACCREDITATION: mountRoute('/credenciamento/:nrSeqAccreditation/tipo-credenciamento/:nrSeqTypeAccreditation'),
  TERM_PROVIDER_ACCREDITATION: mountRoute('/credenciamento'),
  MY_DATA: mountRoute('/meus-dados'),
  PRIVACY: mountRoute('/privacidade'),
  CHANGE_PW: mountRoute('/meus-dados/alterar-senha'),
  ASSIGN_PRIVACY_WARNING: mountRoute('/aviso-de-privacidade/:nrSeqPrivacy'),
  ASSIGN_TERM_USE: mountRoute('/termo-de-uso/:nrSeqTerm'),
  FORM_TECHNICAL_VISIT: mountRoute('/form-technical-visit'),
  TECHNICAL_VISIT_APPOINTMENTS:  mountRoute('/visita-tecnica/:nrSeqVisit/agendamentos'),
  TECHNICAL_VISIT_FORMS:  mountRoute('/visita-tecnica/:nrSeqVisit/formularios/:nrSeqForm'),
  TECHNICAL_VISIT_INCONSISTENCIES:  mountRoute('/visita-tecnica/:nrSeqVisit/inconsistencias'),
  NEGOTIATION_DETAILS: mountRoute('/historico-negociacoes/negociacao/:nrSeqNegotiation'),
  NEGOTIATION_PROPOSAL: mountRoute('/historico-negociacoes/negociacao/:nrSeqNegotiation/proposta/:nrSeqProposal/negociacao-valores'),
  CALL_CATEGORY: mountRoute('/chamados/tipo-solicitacao'),
  NEGOTIATION_PROPOSAL_DRAFT: mountRoute('/historico-negociacoes/negociacao/:nrSeqNegotiation/proposta/:nrSeqProposal/minuta-contratual'),
};
